import React from 'react';
import { titleCase } from 'change-case';

import Text from 'pods/forms/components/inputs/Text';
import TextArea from 'pods/forms/components/inputs/TextArea';
import Select from 'pods/forms/components/inputs/Select';
import AddressAutocomplete from 'pods/forms/components/inputs/AddressAutocomplete';
import AddressAutocompleteAxios from 'pods/forms/components/inputs/AddressAutocomplete/AddressAutocompleteAxios';
import FundsAutocomplete from 'pods/forms/components/inputs/FundsAutocomplete';
import RadioCheckbox from 'pods/forms/components/inputs/RadioCheckbox';
import FormRichText from 'pods/forms/components/base/FormRichText';
import Section from 'pods/forms/components/structural/Section';
import SubLayout from 'pods/forms/components/structural/FormSubLayout';
import CardContainer from 'pods/forms/components/structural/CardContainer';
import FormReview from 'pods/forms/components/related/FormReview';
import HelpLinkModal from 'pods/forms/components/related/HelpLinkModal';
import IFormFieldProps from 'pods/forms/components/formFieldProps.d';
import BPAYInfo from 'core/components/BPAYInfo';
import Captcha from 'pods/forms/components/inputs/Captcha';
import LoadingContent from './components/related/LoadingContent';
import MessageBlock from './components/related/MessageBlock';
import ModalInCta from './components/related/ModalInCta';

/**
 * Shorthand component export for radio checkbox variants.
 */
const getRadioCheckboxVariant = (type: string) => {
	const Component = (props: any) => <RadioCheckbox type={type} {...props} />;

	Component.displayName = titleCase(type);

	return Component;
};

/**
 * Map the data object to the component props.
 *
 * @param type - element type for React to create
 */
const mapDataToProp = (type: any) => ({
	children,
	config,
}: IFormFieldProps & { children: any }) => {
	const { data } = config;

	return React.createElement(type, data, children);
};

export default {
	// Structural
	// ------------------------
	'section': {
		component: Section,
		defaultValue: '',
	},
	'sub-layout': {
		component: SubLayout,
		defaultValue: '',
	},
	'richtext': {
		component: FormRichText,
		defaultValue: '',
	},
	'card-container': {
		component: CardContainer,
		defaultValue: '',
	},
	// Inputs
	// ------------------------
	'text': {
		component: Text,
		defaultValue: '',
	},
	'textarea': {
		component: TextArea,
		defaultValue: '',
	},
	'select': {
		component: Select,
		defaultValue: '',
	},
	'checkbox': {
		component: getRadioCheckboxVariant('checkbox'),
		defaultValue: '',
	},
	'radio': {
		component: getRadioCheckboxVariant('radio'),
		defaultValue: '',
	},
	'switch': {
		component: getRadioCheckboxVariant('switch'),
		defaultValue: '',
	},
	'address-autocomplete': {
		component: AddressAutocomplete,
	},
	'address-autocomplete-with-axios': {
		component: AddressAutocompleteAxios,
		defaultValue: '',
	},
	'funds-autocomplete': {
		component: FundsAutocomplete,
		defaultValue: '',
	},

	// Multi-step form components
	// ------------------------
	'help-link-modal': {
		component: mapDataToProp(HelpLinkModal),
		defaultValue: '',
	},
	'loading-content': {
		component: mapDataToProp(LoadingContent),
		defaultValue: '',
	},
	'message-block': {
		component: mapDataToProp(MessageBlock),
		defaultValue: '',
	},
	'modal-in-cta': {
		component: mapDataToProp(ModalInCta),
		defaultValue: '',
	},

	// Custom components
	// ------------------------
	'bpay-info': {
		component: mapDataToProp(BPAYInfo),
		defaultValue: '',
	},
	'form-review': {
		component: mapDataToProp(FormReview),
	},
	'captcha': {
		component: Captcha,
		defaultValue: '',
	},
	'custom': {
		component: ({ config: { data }, ...props }: any) =>
			data.component({ ...data.componentProps, ...props }),
		defaultValue: '',
	},
};
